module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getTabClass()
  }, [_c('div', {
    class: _vm.getTabHeaderClass()
  }, [_c('a', {
    staticClass: "p-accordion-header-link",
    attrs: {
      "role": "tab",
      "tabindex": _vm.disabled ? null : '0',
      "aria-expanded": _vm.isTabActive(),
      "id": _vm.ariaId + '_header',
      "aria-controls": _vm.ariaId + '_content'
    },
    on: {
      "click": _vm.onTabClick,
      "keydown": _vm.onTabKeydown
    }
  }, [_c('span', {
    class: _vm.getHeaderIcon()
  }), _vm._v(" "), (_vm.header) ? _c('span', {
    staticClass: "p-accordion-header-text"
  }, [_vm._v(_vm._s(_vm.header))]) : _vm._e(), _vm._v(" "), _vm._t("header")], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-toggleable-content"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTabActive()),
      expression: "isTabActive()"
    }],
    staticClass: "p-toggleable-content",
    attrs: {
      "role": "region",
      "id": _vm.ariaId + '_content',
      "aria-labelledby": _vm.ariaId + '_header'
    }
  }, [_c('div', {
    staticClass: "p-accordion-content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c88384d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/accordiontab/AccordionTab.vue
// module id = 2344
// module chunks = 0